export class PackageReqModel {
	public name: string;
	public monthlyRental: number;
	public conversationMsg: string;
	public businessMsg: string;
	public contacts: string;
	public isMultipleFlow: boolean;
	public tps: number;
	public multichatLiveAgent: string;
	public multichatLiveSupervisor: string;
	public numberOfFlow: string;
	public waOfficialAccount: string;
	public dashboardToSendMessage: string;
	public reportAdminPanel: string;
	public trainingSupport: string;
	public isMultiple: string;
	public checklistWa:	boolean;
	public checklistTele:	boolean;
	public checklistLine:	boolean;
	public specifyPackage: string;
	public customDevelopment: string;
	public oneUsageCostConversation: string;
	public ovrUsgConversationRateCard: boolean;
	public ovrUsgNotficationRateCard: boolean | string;
	public ovrUsgConversationCost: string;
	public ovrUsgNotficationCost: string;
	public signupOrSetup: string;
	public checklistAdm: boolean;
	public checklistUser: boolean;
	public checklistClient: boolean;
	public checklistChatAgentAdmin: boolean;
	public checklistChatAgentUser: boolean;
	public country: string;
	public currency: string;
	public customPackage: boolean;
	public costPerCustomer: string;
	public costPerBusiness: string;
	public setupFeeRateCard: boolean | string;
	public setupFee: string;
	public type: string;
	public recomended: string;

	

	public clone(source: any): PackageReqModel {
		if (source.country) {
			this.country = source.country;
		}
		if (source.recomended) {
			this.recomended = source.recomended;
		}
		if (source.type) {
			this.type = source.type;
		}
		if (source.setupFeeRateCard) {
			this.setupFeeRateCard = source.setupFeeRateCard;
		}
		if (source.setupFee) {
			if(source.setupFeeRateCard === 'true') {
				this.setupFee = null;
			}else {
				this.setupFee = source.setupFee;
			}
		}
		if (source.ovrUsgConversationRateCard) {
			this.ovrUsgConversationRateCard = source.ovrUsgConversationRateCard;
		}
		if (source.costPerCustomer) {
			this.costPerCustomer = source.costPerCustomer;
		}
		if (source.costPerBusiness) {
			this.costPerBusiness = source.costPerBusiness;
		}
		if (source.ovrUsgNotficationRateCard) {
				this.ovrUsgNotficationRateCard = source.ovrUsgNotficationRateCard;
		}
		if (source.ovrUsgConversationCost) {
			this.ovrUsgConversationCost = source.ovrUsgConversationCost;
		}
		if (source.ovrUsgNotficationCost) {
			if(source.ovrUsgNotficationRateCard === 'true') {
				this.ovrUsgNotficationCost = null;
			}else {
				this.ovrUsgNotficationCost = source.ovrUsgNotficationCost;
			}
			
		}
		if (source.customPackage) {
			this.customPackage = source.customPackage;
		}
		if (source.currency) {
			this.currency = source.currency;
		}
		if (source.name) {
			this.name = source.name;
		}
		if (source.monthlyRental) {
			this.monthlyRental = source.monthlyRental;
		}
		if (source.conversationMsg) {
			this.conversationMsg = source.conversationMsg;
		}
		if (source.businessMsg) {
			this.businessMsg = source.businessMsg;
		}
		if (source.contacts) {
			this.contacts = source.contacts;
		}
		if (source.isMultipleFlow) {
			this.isMultipleFlow = source.isMultipleFlow;
		}
		if (source.tps) {
			this.tps = source.tps;
		}
		if (source.multichatLiveAgent) {
			this.multichatLiveAgent = source.multichatLiveAgent;
		}
		if (source.multichatLiveSupervisor) {
			this.multichatLiveSupervisor = source.multichatLiveSupervisor;
		}
		if (source.numberOfFlow) {
			this.numberOfFlow = source.numberOfFlow;
		}
		if (source.waOfficialAccount) {
			this.waOfficialAccount = source.waOfficialAccount;
		}
		if (source.dashboardToSendMessage) {
			this.dashboardToSendMessage = source.dashboardToSendMessage;
		}
		if (source.reportAdminPanel) {
			this.reportAdminPanel = source.reportAdminPanel;
		}
		if (source.trainingSupport) {
			this.trainingSupport = source.trainingSupport;
		}
		if (source.isMultiple) {
			this.isMultiple = source.isMultiple;
		}
		if (source.checklistWa) {
			this.checklistWa = source.checklistWa;
		}
		if (source.checklistLine) {
			this.checklistLine = source.checklistLine;
		}
		if (source.checklistTele) {
			this.checklistTele = source.checklistTele;
		}
		if (source.specifyPackage) {
			this.specifyPackage = source.specifyPackage;
		}
		if (source.customDevelopment) {
			this.customDevelopment = source.customDevelopment;
		}
		if (source.oneUsageCostConversation) {
			this.oneUsageCostConversation = source.oneUsageCostConversation;
		}
		// if (source.oneUsageCostNotification) {
		// 	this.oneUsageCostNotification = source.oneUsageCostNotification;
		// }
		if (source.signupOrSetup) {
			this.signupOrSetup = source.signupOrSetup;
		}
		if (source.checklistAdm) {
			this.checklistAdm = source.checklistAdm;
		}
		if (source.checklistUser) {
			this.checklistUser = source.checklistUser;
		}
		if (source.checklistClient) {
			this.checklistClient = source.checklistClient;
		}
		if (source.checklistChatAgentAdmin) {
			this.checklistChatAgentAdmin = source.checklistChatAgentAdmin;
		}
		if (source.checklistChatAgentUser) {
			this.checklistChatAgentUser = source.checklistChatAgentUser;
		}
		return this;
	}
}